import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Investissements from "@/pages/Investissements";
import Portfolio from "@/pages/Portfolio";
import Conformite from "@/pages/Conformite";
import Equipe from "@/pages/Equipe";
import Cabinet from "@/pages/Cabinet";
import Mentions from "@/pages/Mentions";
import Contact from "@/pages/Contact";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 120);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/investissements" element={<Investissements />} />
            <Route path="/investissements/portfolio" element={<Portfolio />} />
            <Route path="/conformite" element={<Conformite />} />
            <Route path="/le-cabinet" element={<Cabinet />} />
            <Route path="/equipe" element={<Equipe />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<Mentions />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
